import { intersectTwo } from "../../../../utils/utils"
import {
  DELIVERY_ACCESSORIALS,
  PICKUP_ACCESSORIALS,
} from "../../../constants"

export const getAccessorialsAfterExclusion = ({
    selectedAccessorials,
    accessorialExclusionList,
    isLiftgateTrailer = false,
  }) => {
    let appliedAccessorialsList = [...selectedAccessorials];
    selectedAccessorials.forEach((accessorialCode) => {
      const accesorialInExclusionObj = accessorialExclusionList?.find(
        (accessorial) => accessorial.code === accessorialCode
      );
      if (accesorialInExclusionObj) {
        accesorialInExclusionObj.exclusionCodes?.forEach((exclusionCodeList) => {
          if (
            intersectTwo(exclusionCodeList, selectedAccessorials).length ===
            exclusionCodeList.length
          ) {
            appliedAccessorialsList = appliedAccessorialsList.filter(
              (appliedAccessorialCode) =>
                !exclusionCodeList.includes(appliedAccessorialCode)
            );
          }
        });
      }
    });
    if (!isLiftgateTrailer) {
      if (appliedAccessorialsList.includes(DELIVERY_ACCESSORIALS.LIFTGATE)) {
        appliedAccessorialsList = appliedAccessorialsList.filter(
          (code) => code !== DELIVERY_ACCESSORIALS.LIFTGATE
        );
      }
      if (appliedAccessorialsList.includes(PICKUP_ACCESSORIALS.LIFTGATE)) {
        appliedAccessorialsList = appliedAccessorialsList.filter(
          (code) => code !== PICKUP_ACCESSORIALS.LIFTGATE
        );
      }
    }
    return appliedAccessorialsList;
  };